import React, { useState, useEffect } from 'react';
import {
  Box, Card, CardContent, Typography, Grid, Switch, TextField, Button,
  Divider, Chip, Tab, Tabs, Alert, IconButton, InputAdornment, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogActions, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Accordion, AccordionSummary,
  AccordionDetails, Snackbar
} from '@mui/material';
import {
  Email, Sms, WhatsApp, CheckCircle, Cancel, Visibility, VisibilityOff,
  Save, Refresh, Info, Send, QrCode2, LinkOff, Schedule, RestartAlt, History,
  ExpandMore, Message, Settings, Assessment, Terminal, Code, ContentCopy, Preview,
  Gavel, VpnKey, OpenInNew, CloudDownload, Android
} from '@mui/icons-material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const APK_DOWNLOAD_URL = 'https://easy-backend.guiameu.com.br/files/aplicativo/easy-locadora.apk';

export default function Integracoes() {
  const [tabAtiva, setTabAtiva] = useState(0);
  const [loading, setLoading] = useState(false);
  const [modalTesteEmail, setModalTesteEmail] = useState(false);
  const [emailTeste, setEmailTeste] = useState('');
  const [enviandoEmailTeste, setEnviandoEmailTeste] = useState(false);
  
  // WhatsApp Baileys
  const [modalQRCode, setModalQRCode] = useState(false);
  const [qrCodeAtual, setQrCodeAtual] = useState(null);
  const [tempoQR, setTempoQR] = useState(120);
  const [enviandoTeste, setEnviandoTeste] = useState(false);
  const [numeroTesteMensagem, setNumeroTesteMensagem] = useState('');
  const [textoTesteMensagem, setTextoTesteMensagem] = useState('');
  const [modalTeste, setModalTeste] = useState(false);
  const [modalAdminWhatsApp, setModalAdminWhatsApp] = useState(false);
  const [historicoMensagens, setHistoricoMensagens] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState('info');

  // Carregar configurações ao montar
  useEffect(() => {
    carregarConfiguracaoEmail();
    carregarStatusWhatsApp();
    
    // Atualizar status do WhatsApp a cada 5 segundos
    const interval = setInterval(() => {
      carregarStatusWhatsApp();
    }, 5000);
    
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Timer do QR Code
  useEffect(() => {
    let timer;
    if (modalQRCode && tempoQR > 0) {
      timer = setInterval(() => {
        setTempoQR(prev => prev - 1);
      }, 1000);
    } else if (modalQRCode && tempoQR <= 0) {
      // QR Code expirou
      console.log('⏱️ QR Code expirou - cancelando conexão');
      cancelarConexaoWhatsApp();
    }
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalQRCode, tempoQR]);

  // Polling rápido (2s) enquanto o modal QR estiver aberto
  useEffect(() => {
    if (!modalQRCode) return;
    const interval = setInterval(() => {
      carregarStatusWhatsApp();
    }, 2000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalQRCode]);

  // Cancelar conexão WhatsApp
  async function cancelarConexaoWhatsApp() {
    try {
      console.log('❌ Cancelando conexão WhatsApp...');
      setModalQRCode(false);
      setQrCodeAtual(null);
      setTempoQR(0);
      
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/whatsapp/cancelar`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('✅ Conexão cancelada e recursos liberados');
    } catch (erro) {
      console.error('Erro ao cancelar conexão:', erro);
    }
  }
  
  // Estados E-mail
  const [emailConfig, setEmailConfig] = useState({
    ativo: false,
    servidor: '',
    porta: '',
    usuario: '',
    senha: '',
    remetente: '',
    ssl: false
  });

  // Estados SMS
  const [smsConfig, setSmsConfig] = useState({
    ativo: false,
    provedor: 'Twilio',
    apiKey: '',
    apiSecret: '',
    numeroRemetente: '+55 11 98765-4321',
    saldoCreditos: 250
  });

  // Estados WhatsApp
  const [whatsappConfig, setWhatsappConfig] = useState({
    conectado: false,
    status: 'desconectado',
    numero: null,
    nome: null,
    qrcode: null,
    ultimaConexao: null
  });

  // Notificação de sucesso na conexão
  const [snackbarSucesso, setSnackbarSucesso] = useState(false);
  // Controla se o modal QR estava aberto (para detectar transição → conectado)
  const qrEraVisivelRef = React.useRef(false);

  // Logs em tempo real (SSE)
  const [logs, setLogs] = useState([]);
  const logsEndRef = React.useRef(null);
  const sseRef = React.useRef(null);

  // Backend Info (Redis, DB, Local)
  const [backendInfo, setBackendInfo] = useState(null);
  const [carregandoBackendInfo, setCarregandoBackendInfo] = useState(false);

  // Notificação genérica (substitui window.alert)
  const [notificacao, setNotificacao] = useState({ aberto: false, mensagem: '', tipo: 'info' });
  // Confirmação genérica (substitui window.confirm)
  const [confirmDialog, setConfirmDialog] = useState({ aberto: false, titulo: '', mensagem: '', resolve: null });
  // Modal de Logs
  const [modalLogsAberto, setModalLogsAberto] = useState(false);
  const [apkInfo, setApkInfo] = useState({ disponivel: true, gerando: false, url: APK_DOWNLOAD_URL, atualizadoEm: null });

  // Estados Widget de Reservas
  const [widgetConfig, setWidgetConfig] = useState({
    titulo: 'Reserve seu carro',
    subtitulo: 'Encontre o veículo ideal para sua viagem',
    corPrimaria: '#FF8C00',
    corTexto: '#ffffff',
    corFundo: '#ffffff',
    labelBotao: 'Buscar Veículos',
    urlDestino: typeof window !== 'undefined' ? `${window.location.origin}/reservar` : 'https://seusite.com.br/reservar',
    mostrarLogo: true,
    nomeEmpresa: 'Easy Locadora',
    borderRadius: '8',
    largura: '100%'
  });
  const [widgetCopiado, setWidgetCopiado] = useState(false);
  const [widgetAba, setWidgetAba] = useState('configurar');

  const [mostrarSenhas, setMostrarSenhas] = useState({});

  // Infosimples (Multas)
  const [infosimplesToken, setInfosimplesToken] = useState('');
  const [infosimplesAtivo, setInfosimplesAtivo] = useState(true);
  const [infosimplesEndpoint, setInfosimplesEndpoint] = useState('detran/am/multas');
  const [infosimplesTokenVisivel, setInfosimplesTokenVisivel] = useState(false);
  const [infosimplesStatus, setInfosimplesStatus] = useState(null);
  const [salvandoInfosimples, setSalvandoInfosimples] = useState(false);

  // Carregar Infosimples ao montar
  useEffect(() => { carregarInfosimples(); }, []);

  useEffect(() => {
    if (tabAtiva === 5) carregarApk();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabAtiva]);

  async function carregarApk() {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/integracoes/aplicativo`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.sucesso) {
        setApkInfo({ ...res.data, disponivel: true, url: res.data.url || APK_DOWNLOAD_URL });
      }
    } catch (e) {
      console.error('Erro ao consultar APK:', e);
      setApkInfo((atual) => ({ ...atual, disponivel: true, url: APK_DOWNLOAD_URL }));
    }
  }

  async function carregarInfosimples() {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/integracoes/infosimples/config`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.sucesso && res.data.dados) {
        const d = res.data.dados;
        setInfosimplesAtivo(!!d.ativo);
        setInfosimplesEndpoint(d.endpoint || 'detran/am/multas');
        setInfosimplesStatus(d);
        // não pré-preenche o campo de token por segurança
      }
    } catch (e) {
      console.error('Erro ao carregar Infosimples:', e);
    }
  }

  async function salvarInfosimples() {
    if (!infosimplesToken.trim()) {
      mostrarNotificacao('Informe o token antes de salvar.', 'warning');
      return;
    }
    setSalvandoInfosimples(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${API_URL}/integracoes/infosimples/salvar`,
        { token: infosimplesToken.trim(), ativo: infosimplesAtivo, endpoint: infosimplesEndpoint.trim() || 'detran/am/multas' },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.sucesso) {
        mostrarNotificacao('Token Infosimples salvo com sucesso!', 'success');
        setInfosimplesToken('');
        carregarInfosimples();
      }
    } catch (e) {
      mostrarNotificacao('Erro ao salvar: ' + (e.response?.data?.mensagem || e.message), 'error');
    } finally {
      setSalvandoInfosimples(false);
    }
  }

  // Carregar configuração E-mail
  async function carregarConfiguracaoEmail() {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/integracoes/email/config`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.sucesso) {
        const dados = response.data.dados;
        setEmailConfig({
          ativo: !!dados.ativo,
          servidor: dados.servidor || 'smtp.gmail.com',
          porta: dados.porta || '587',
          usuario: dados.usuario || '',
          senha: dados.senha || '',
          remetente: dados.remetente || 'Easy Locadora',
          ssl: dados.ssl || false
        });
      }
    } catch (erro) {
      console.error('Erro ao carregar configuração de e-mail:', erro);
      // Se não existir, manter valores padrão
    }
  }

  // Salvar configuração E-mail
  const salvarConfiguracaoEmail = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/integracoes/email/salvar`, 
        emailConfig,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.data.sucesso) {
        mostrarNotificacao('Configurações de e-mail salvas com sucesso!', 'success');
        carregarConfiguracaoEmail(); // Recarregar para atualizar a senha mascarada
      }
    } catch (erro) {
      console.error('Erro ao salvar configuração:', erro);
      mostrarNotificacao('Erro ao salvar configurações: ' + (erro.response?.data?.erro || erro.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Testar configuração E-mail
  const testarConfiguracaoEmail = async () => {
    try {
      if (!emailTeste) {
        mostrarNotificacao('Informe um e-mail para teste', 'warning');
        return;
      }

      setEnviandoEmailTeste(true);
      const token = localStorage.getItem('token');

      const response = await axios.post(`${API_URL}/integracoes/email/testar`,
        { emailTeste },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.sucesso) {
        mostrarNotificacao(response.data.mensagem, 'success');
        setModalTesteEmail(false);
        setEmailTeste('');
      }
    } catch (erro) {
      console.error('Erro ao testar e-mail:', erro);
      const mensagemErro = erro.response?.data?.detalhes || erro.response?.data?.erro || erro.message;
      mostrarNotificacao('Erro ao enviar e-mail de teste: ' + mensagemErro, 'error');
    } finally {
      setEnviandoEmailTeste(false);
    }
  };

  // Carregar status WhatsApp
  async function carregarStatusWhatsApp() {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/whatsapp/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.sucesso) {
        const dados = response.data.dados;
        setWhatsappConfig(dados);

        if (dados.status === 'qrcode' && dados.qrcode) {
          // Atualiza a imagem do QR Code e abre o modal.
          setQrCodeAtual(dados.qrcode);
          setModalQRCode(true);
          setTempoQR(prev => (prev > 0 ? prev : 120));
          qrEraVisivelRef.current = true;
        }

        if (dados.conectado) {
          // Conexão estabelecida: fecha o modal e mostra sucesso se QR estava visível
          if (qrEraVisivelRef.current) {
            setSnackbarSucesso(true);
            qrEraVisivelRef.current = false;
          }
          setModalQRCode(false);
          setQrCodeAtual(null);
        }
      }
    } catch (erro) {
      console.error('Erro ao carregar status WhatsApp:', erro);
    }
  }

  // Conectar ao SSE de logs
  function conectarSSELogs() {
    if (sseRef.current) sseRef.current.close();
    const token = localStorage.getItem('token');
    const evtSource = new EventSource(`${API_URL}/whatsapp/logs?token=${token}`);
    evtSource.onmessage = (e) => {
      try {
        const log = JSON.parse(e.data);
        setLogs(prev => {
          const novo = [...prev, log];
          return novo.length > 200 ? novo.slice(-200) : novo;
        });
      } catch (_e) { /* ignore parse errors */ }
    };
    evtSource.onerror = () => evtSource.close();
    sseRef.current = evtSource;
  }

  function desconectarSSELogs() {
    if (sseRef.current) { sseRef.current.close(); sseRef.current = null; }
  }

  // Auto-scroll no terminal
  React.useEffect(() => {
    if (modalLogsAberto && logsEndRef.current) {
      logsEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [logs, modalLogsAberto]);

  const conectarWhatsApp = async () => {
    try {
      setLoading(true);

      // Abre o modal imediatamente com spinner — QR chegará via polling
      setQrCodeAtual(null);
      setModalQRCode(true);
      setTempoQR(120);
      qrEraVisivelRef.current = true;

      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/whatsapp/conectar`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.qrcode) {
        // QR Code já estava pronto (sessão parcial)
        setQrCodeAtual(response.data.qrcode);
      } else if (response.data.dados?.conectado) {
        setWhatsappConfig(response.data.dados);
        setSnackbarSucesso(true);
        setModalQRCode(false);
        qrEraVisivelRef.current = false;
      }
      // status 'connecting' ou 'reconectando': QR chegará via polling de /status
    } catch (erro) {
      console.error('❌ Erro ao conectar:', erro);
      setModalQRCode(false);
      qrEraVisivelRef.current = false;
      mostrarNotificacao('Erro ao conectar WhatsApp: ' + (erro.response?.data?.erro || erro.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Enviar mensagem de teste
  const enviarMensagemTeste = async () => {
    try {
      setEnviandoTeste(true);
      const token = localStorage.getItem('token');
      
      // Limpar número (remover formatação) e garantir formato correto
      const numeroLimpo = numeroTesteMensagem.replace(/\D/g, '');
      
      // Validar número
      if (numeroLimpo.length < 10 || numeroLimpo.length > 13) {
        mostrarNotificacao('Número inválido! Use o formato: (DD) 9XXXX-XXXX', 'warning');
        return;
      }

      console.log('📤 Enviando para número limpo:', numeroLimpo);

      const response = await axios.post(`${API_URL}/whatsapp/enviar`,
        {
          numero: numeroLimpo,
          mensagem: textoTesteMensagem
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.sucesso) {
        mostrarNotificacao('Mensagem enviada com sucesso!', 'success');
        setNumeroTesteMensagem('');
        setTextoTesteMensagem('');
        setModalTeste(false);
      }
    } catch (erro) {
      console.error('Erro ao enviar:', erro);
      mostrarNotificacao('Erro ao enviar mensagem: ' + (erro.response?.data?.erro || erro.message), 'error');
    } finally {
      setEnviandoTeste(false);
    }
  };

  // Desconectar WhatsApp
  const desconectarWhatsApp = async () => {
    const confirmado = await aguardarConfirmacao('Desconectar WhatsApp', 'Tem certeza que deseja desconectar?');
    if (!confirmado) return;

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/whatsapp/desconectar`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.sucesso) {
        setWhatsappConfig({
          conectado: false,
          status: 'desconectado',
          numero: null,
          nome: null,
          qrcode: null
        });
        desconectarSSELogs();
        mostrarNotificacao('Desconectado com sucesso!', 'success');
      }
    } catch (erro) {
      console.error('Erro ao desconectar:', erro);
      mostrarNotificacao('Erro ao desconectar: ' + (erro.response?.data?.erro || erro.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Resetar WhatsApp (desconectar + limpar tudo)
  const resetarWhatsApp = async () => {
    const confirmado = await aguardarConfirmacao('Resetar Conexão', 'Desconectar e deletar TODAS as credenciais? Esta ação não pode ser desfeita.');
    if (!confirmado) return;

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/whatsapp/resetar`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.sucesso) {
        setWhatsappConfig({
          conectado: false,
          status: 'desconectado',
          numero: null,
          nome: null,
          qrcode: null
        });
        setQrCodeAtual(null);
        desconectarSSELogs();
        setLogs([]);
        mostrarNotificacao('WhatsApp resetado! Pronto para nova autenticação.', 'success');
      }
    } catch (erro) {
      console.error('Erro ao resetar:', erro);
      mostrarNotificacao('Erro ao resetar: ' + (erro.response?.data?.erro || erro.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Carregar histórico de mensagens
  const carregarHistoricoMensagens = async () => {
    try {
      setLoadingHistorico(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/whatsapp/historico`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.sucesso) {
        setHistoricoMensagens(response.data.dados || []);
      }
    } catch (erro) {
      console.error('Erro ao carregar histórico:', erro);
    } finally {
      setLoadingHistorico(false);
    }
  };

  // Carregar info do backend
  const carregarBackendInfo = async () => {
    try {
      setCarregandoBackendInfo(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/whatsapp/backend-info`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.sucesso) {
        setBackendInfo(response.data.dados);
      }
    } catch (erro) {
      console.error('Erro ao carregar backend info:', erro);
    } finally {
      setCarregandoBackendInfo(false);
    }
  };

  // Reconectar com novo QR Code
  const reconectarWhatsApp = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/whatsapp/reconectar`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.sucesso) {
        mostrarNotificacao('Reconexão iniciada! Novo QR Code será gerado...', 'info');
        setQrCodeAtual(null);
        setModalQRCode(true);
        setTempoQR(120);
        qrEraVisivelRef.current = true;
      }
    } catch (erro) {
      console.error('Erro ao reconectar:', erro);
      mostrarNotificacao('Erro ao reconectar: ' + (erro.response?.data?.erro || erro.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Limpar TUDO (Redis + DB + Local)
  const limparTudo = async () => {
    const confirmado = await aguardarConfirmacao(
      '⚠️ Limpar TUDO',
      'Isso vai deletar TODAS as credenciais (Redis + Database + Local). Você precisará conectar um número diferente. Tem certeza?'
    );
    if (!confirmado) return;

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/whatsapp/limpar-tudo`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.sucesso) {
        mostrarNotificacao('✨ ' + response.data.mensagem, 'success');
        setWhatsappConfig({
          conectado: false,
          status: 'desconectado',
          numero: null,
          nome: null,
          qrcode: null
        });
        setQrCodeAtual(null);
        setModalQRCode(false);
        desconectarSSELogs();
        setLogs([]);
        carregarStatusWhatsApp();
      }
    } catch (erro) {
      console.error('Erro ao limpar:', erro);
      mostrarNotificacao('Erro ao limpar: ' + (erro.response?.data?.erro || erro.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Abrir modal administrativo
  const abrirAdministracao = () => {
    carregarHistoricoMensagens();
    carregarBackendInfo();
    setModalAdminWhatsApp(true);
  };

  const handleTabChange = (event, novaTab) => {
    setTabAtiva(novaTab);
  };

  const toggleMostrarSenha = (campo) => {
    setMostrarSenhas(prev => ({ ...prev, [campo]: !prev[campo] }));
  };

  const salvarConfiguracao = (tipo) => {
    if (tipo === 'WhatsApp') {
      mostrarNotificacao('Configurações do WhatsApp salvas automaticamente', 'success');
    } else {
      mostrarNotificacao(`Configurações de ${tipo} salvas com sucesso!`, 'success');
    }
  };

  const testarConexao = (tipo) => {
    if (tipo === 'WhatsApp') {
      if (whatsappConfig.conectado) {
        mostrarNotificacao('WhatsApp conectado e funcionando!', 'success');
      } else {
        conectarWhatsApp();
      }
    } else {
      mostrarNotificacao(`Testando conexão com ${tipo}...`, 'info');
    }
  };

  const mostrarNotificacao = (mensagem, tipo = 'info') => {
    setNotificacao({ aberto: true, mensagem, tipo });
  };

  const aguardarConfirmacao = (titulo, mensagem) => new Promise((resolve) => {
    setConfirmDialog({ aberto: true, titulo, mensagem, resolve });
  });

  return (
    <Box sx={{ p: 3 }}>
      {/* Cabeçalho */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: '#FF8C00', mb: 1 }}>
          Integrações
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Configure as integrações de comunicação da sua locadora
        </Typography>
      </Box>

      {/* Tabs */}
      <Card sx={{ mb: 3 }}>
        <Tabs
          value={tabAtiva}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': { minWidth: 120 },
            '& .Mui-selected': { color: '#FF8C00' },
            '& .MuiTabs-indicator': { backgroundColor: '#FF8C00' }
          }}
        >
          <Tab icon={<Email />} label="E-mail" iconPosition="start" />
          <Tab icon={<Sms />} label="SMS" iconPosition="start" />
          <Tab icon={<WhatsApp />} label="WhatsApp" iconPosition="start" />
          <Tab icon={<Code />} label="Widget de Reservas" iconPosition="start" />
          <Tab icon={<Gavel />} label="Infosimples (Multas)" iconPosition="start" />
          <Tab icon={<Android />} label="Aplicativo" iconPosition="start" />
        </Tabs>
      </Card>

      {/* Conteúdo das Tabs */}
      {/* TAB E-MAIL */}
      {tabAtiva === 0 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Email sx={{ fontSize: 40, color: '#FF8C00' }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Configuração de E-mail
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Configure o servidor SMTP para envio de e-mails
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" color="text.secondary">Status:</Typography>
                <Chip
                  icon={emailConfig.ativo ? <CheckCircle /> : <Cancel />}
                  label={emailConfig.ativo ? 'Ativo' : 'Inativo'}
                  color={emailConfig.ativo ? 'success' : 'default'}
                  size="small"
                />
                <Switch
                  checked={emailConfig.ativo}
                  onChange={(e) => setEmailConfig({ ...emailConfig, ativo: e.target.checked })}
                  color="warning"
                />
              </Box>
            </Box>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Servidor SMTP"
                  value={emailConfig.servidor}
                  onChange={(e) => setEmailConfig({ ...emailConfig, servidor: e.target.value })}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Porta"
                  value={emailConfig.porta}
                  onChange={(e) => setEmailConfig({ ...emailConfig, porta: e.target.value })}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Usuário"
                  value={emailConfig.usuario}
                  onChange={(e) => setEmailConfig({ ...emailConfig, usuario: e.target.value })}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Senha"
                  type={mostrarSenhas.email ? 'text' : 'password'}
                  value={emailConfig.senha}
                  onChange={(e) => setEmailConfig({ ...emailConfig, senha: e.target.value })}
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => toggleMostrarSenha('email')} edge="end" size="small">
                          {mostrarSenhas.email ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Nome do Remetente"
                  value={emailConfig.remetente}
                  onChange={(e) => setEmailConfig({ ...emailConfig, remetente: e.target.value })}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Switch
                    checked={emailConfig.ssl}
                    onChange={(e) => setEmailConfig({ ...emailConfig, ssl: e.target.checked })}
                    color="warning"
                  />
                  <Typography variant="body2">Usar SSL/TLS</Typography>
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                variant="contained"
                startIcon={<Save />}
                onClick={salvarConfiguracaoEmail}
                disabled={loading}
                sx={{ bgcolor: '#FF8C00', '&:hover': { bgcolor: '#E67E00' } }}
              >
                {loading ? 'Salvando...' : 'Salvar Configurações'}
              </Button>
              <Button
                variant="outlined"
                startIcon={<Send />}
                onClick={() => setModalTesteEmail(true)}
                sx={{ borderColor: '#FF8C00', color: '#FF8C00' }}
              >
                Enviar E-mail de Teste
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* TAB SMS */}
      {tabAtiva === 1 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Sms sx={{ fontSize: 40, color: '#FF8C00' }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Configuração de SMS
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Configure o provedor para envio de SMS
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" color="text.secondary">Status:</Typography>
                <Chip
                  icon={smsConfig.ativo ? <CheckCircle /> : <Cancel />}
                  label={smsConfig.ativo ? 'Ativo' : 'Inativo'}
                  color={smsConfig.ativo ? 'success' : 'default'}
                  size="small"
                />
                <Switch
                  checked={smsConfig.ativo}
                  onChange={(e) => setSmsConfig({ ...smsConfig, ativo: e.target.checked })}
                  color="warning"
                />
              </Box>
            </Box>

            <Divider sx={{ mb: 3 }} />

            {!smsConfig.ativo && (
              <Alert severity="info" icon={<Info />} sx={{ mb: 3 }}>
                Ative o envio de SMS para configurar as credenciais do provedor
              </Alert>
            )}

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Provedor"
                  value={smsConfig.provedor}
                  onChange={(e) => setSmsConfig({ ...smsConfig, provedor: e.target.value })}
                  size="small"
                  disabled={!smsConfig.ativo}
                  helperText="Ex: Twilio, Zenvia, TotalVoice"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Número Remetente"
                  value={smsConfig.numeroRemetente}
                  onChange={(e) => setSmsConfig({ ...smsConfig, numeroRemetente: e.target.value })}
                  size="small"
                  disabled={!smsConfig.ativo}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="API Key"
                  type={mostrarSenhas.smsKey ? 'text' : 'password'}
                  value={smsConfig.apiKey}
                  onChange={(e) => setSmsConfig({ ...smsConfig, apiKey: e.target.value })}
                  size="small"
                  disabled={!smsConfig.ativo}
                  placeholder="Insira sua API Key"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => toggleMostrarSenha('smsKey')} edge="end" size="small">
                          {mostrarSenhas.smsKey ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="API Secret"
                  type={mostrarSenhas.smsSecret ? 'text' : 'password'}
                  value={smsConfig.apiSecret}
                  onChange={(e) => setSmsConfig({ ...smsConfig, apiSecret: e.target.value })}
                  size="small"
                  disabled={!smsConfig.ativo}
                  placeholder="Insira sua API Secret"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => toggleMostrarSenha('smsSecret')} edge="end" size="small">
                          {mostrarSenhas.smsSecret ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Alert severity="success" sx={{ bgcolor: '#e8f5e9' }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Saldo de Créditos: {smsConfig.saldoCreditos} SMS
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Mensagens disponíveis para envio
                  </Typography>
                </Alert>
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                variant="contained"
                startIcon={<Save />}
                onClick={() => salvarConfiguracao('SMS')}
                disabled={!smsConfig.ativo}
                sx={{ bgcolor: '#FF8C00', '&:hover': { bgcolor: '#E67E00' } }}
              >
                Salvar Configurações
              </Button>
              <Button
                variant="outlined"
                startIcon={<Refresh />}
                onClick={() => testarConexao('SMS')}
                disabled={!smsConfig.ativo}
                sx={{ borderColor: '#FF8C00', color: '#FF8C00' }}
              >
                Testar Envio
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}


            {/* 
      {/* TAB WHATSAPP */}
      {tabAtiva === 2 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <WhatsApp sx={{ fontSize: 40, color: '#25D366' }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    WhatsApp
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Conecte seu WhatsApp direto no sistema (100% GRÁTIS)
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip
                  icon={whatsappConfig.conectado ? <CheckCircle /> : <Cancel />}
                  label={whatsappConfig.conectado ? 'Conectado' : 'Desconectado'}
                  color={whatsappConfig.conectado ? 'success' : 'error'}
                  size="small"
                />
              </Box>
            </Box>

            <Divider sx={{ mb: 3 }} />

            {/* Status Conectado */}
            {whatsappConfig.conectado && (
              <Alert severity="success" icon={<CheckCircle />} sx={{ mb: 3 }}>
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    ✅ WhatsApp Conectado!
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    <strong>Número:</strong> {whatsappConfig.numero}
                  </Typography>
                  {whatsappConfig.nome && (
                    <Typography variant="body2">
                      <strong>Nome:</strong> {whatsappConfig.nome}
                    </Typography>
                  )}
                  {whatsappConfig.ultimaConexao && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                      Última conexão: {new Date(whatsappConfig.ultimaConexao).toLocaleString('pt-BR')}
                    </Typography>
                  )}
                </Box>
              </Alert>
            )}

            {/* Status QR Code */}
            {whatsappConfig.status === 'qrcode' && (
              <Alert severity="warning" sx={{ mb: 3 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  ⏳ Aguardando leitura do QR Code
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Escaneie o código com sua câmera do WhatsApp
                </Typography>
              </Alert>
            )}

            {/* Status Desconectado */}
            {!whatsappConfig.conectado && whatsappConfig.status !== 'qrcode' && (
              <Alert severity="info" sx={{ mb: 3 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  📱 Clique em &quot;Conectar WhatsApp&quot; para começar
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Iremos gerar um QR Code para você escanear com seu celular
                </Typography>
              </Alert>
            )}

            {/* Informações */}
            <Paper sx={{ p: 2, mb: 3, bgcolor: '#f5f5f5' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                ℹ️ Como Funciona:
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 2 }}>
                <ol style={{ margin: '8px 0', paddingLeft: '20px' }}>
                  <li>Clique em &quot;Conectar WhatsApp&quot;</li>
                  <li>Um QR Code será gerado automaticamente</li>
                  <li>Abra WhatsApp no seu celular → Dispositivos Conectados → Conectar</li>
                  <li>Escaneie o QR Code com a câmera</li>
                  <li>Seu WhatsApp estará pronto para enviar mensagens automáticas!</li>
                </ol>
              </Typography>
            </Paper>

            {/* Botões de Ação */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              {!whatsappConfig.conectado ? (
                <Button
                  variant="contained"
                  startIcon={whatsappConfig.status === 'qrcode' ? <CircularProgress size={20} /> : <QrCode2 />}
                  onClick={conectarWhatsApp}
                  disabled={loading}
                  sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#128C7E' } }}
                >
                  {loading ? 'Conectando...' : 'Conectar WhatsApp'}
                </Button>
              ) : (
                <>
                  <Button
                    variant="contained"
                    startIcon={<Send />}
                    onClick={() => setModalTeste(true)}
                    disabled={loading}
                    color="success"
                  >
                    Enviar Mensagem de Teste
                  </Button>

                  <Button
                    variant="outlined"
                    startIcon={<Refresh />}
                    onClick={carregarStatusWhatsApp}
                    disabled={loading}
                    sx={{ borderColor: '#25D366', color: '#25D366' }}
                  >
                    Atualizar Status
                  </Button>

                  <Button
                    variant="outlined"
                    startIcon={<QrCode2 />}
                    onClick={reconectarWhatsApp}
                    disabled={loading}
                    sx={{ borderColor: '#FFA500', color: '#FFA500' }}
                  >
                    Gerar Novo QR Code
                  </Button>

                  <Button
                    variant="outlined"
                    startIcon={<LinkOff />}
                    onClick={desconectarWhatsApp}
                    disabled={loading}
                    color="error"
                  >
                    Desconectar
                  </Button>

                  <Button
                    variant="outlined"
                    startIcon={<RestartAlt />}
                    onClick={resetarWhatsApp}
                    disabled={loading}
                    color="warning"
                  >
                    Resetar Conexão
                  </Button>

                  <Button
                    variant="contained"
                    startIcon={<LinkOff />}
                    onClick={limparTudo}
                    disabled={loading}
                    sx={{ bgcolor: '#D32F2F', '&:hover': { bgcolor: '#B71C1C' } }}
                  >
                    🔥 Limpar TUDO (Novo Número)
                  </Button>

                  <Button
                    variant="outlined"
                    startIcon={<Settings />}
                    onClick={abrirAdministracao}
                    disabled={loading}
                    sx={{ borderColor: '#FF8C00', color: '#FF8C00' }}
                  >
                    Administração
                  </Button>
                </>
              )}
            </Box>

            {/* Botão para abrir logs ao vivo */}
            <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                variant="outlined"
                startIcon={<Terminal />}
                onClick={() => { setModalLogsAberto(true); if (!sseRef.current) conectarSSELogs(); }}
                sx={{ borderColor: '#25D366', color: '#25D366', fontSize: 12 }}
                size="small"
              >
                Ver Logs ao Vivo
              </Button>
              {sseRef.current && (
                <Chip label="AO VIVO" color="success" size="small" />
              )}
            </Box>

            {/* Painel Administrativo - Estatísticas */}
            {whatsappConfig.conectado && (
              <Box sx={{ mt: 4 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#25D366' }}>
                  📊 Painel Administrativo
                </Typography>

                <Grid container spacing={2}>
                  {/* Card: Sessão Ativa */}
                  <Grid item xs={12} md={6} lg={3}>
                    <Card sx={{ bgcolor: '#e8f5e9', border: '1px solid #4caf50' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Box>
                            <Typography variant="caption" color="text.secondary">
                              Status da Sessão
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: '#2e7d32' }}>
                              Ativa
                            </Typography>
                          </Box>
                          <CheckCircle sx={{ fontSize: 40, color: '#4caf50' }} />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Card: Sessão */}
                  <Grid item xs={12} md={6} lg={3}>
                    <Card sx={{ bgcolor: '#e3f2fd', border: '1px solid #2196f3' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Box>
                            <Typography variant="caption" color="text.secondary">
                              Armazenamento
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              Local
                            </Typography>
                          </Box>
                          <Terminal sx={{ fontSize: 40, color: '#2196f3' }} />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Card: Número Conectado */}
                  <Grid item xs={12} md={6} lg={3}>
                    <Card sx={{ bgcolor: '#f3e5f5', border: '1px solid #9c27b0' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Box>
                            <Typography variant="caption" color="text.secondary">
                              Número Conectado
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {whatsappConfig.numero ? `+${whatsappConfig.numero}` : '-'}
                            </Typography>
                          </Box>
                          <WhatsApp sx={{ fontSize: 40, color: '#9c27b0' }} />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Card: Mensagens */}
                  <Grid item xs={12} md={6} lg={3}>
                    <Card sx={{ bgcolor: '#fff8e1', border: '1px solid #ffc107' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Box>
                            <Typography variant="caption" color="text.secondary">
                              Mensagens (Hoje)
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              {historicoMensagens.length}
                            </Typography>
                          </Box>
                          <Message sx={{ fontSize: 40, color: '#ffa000' }} />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
            )}
          </CardContent>
        </Card>
      )}

      {/* TAB WIDGET DE RESERVAS */}
      {tabAtiva === 3 && (
        <Box>
          {/* Cabeçalho */}
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Code sx={{ fontSize: 40, color: '#FF8C00' }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>Widget de Busca para Locação</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Gere um código HTML+JavaScript para adicionar uma barra de pesquisa de locação no seu site externo
                  </Typography>
                </Box>
              </Box>

              {/* Abas internas */}
              <Tabs
                value={widgetAba}
                onChange={(e, v) => setWidgetAba(v)}
                sx={{ borderBottom: 1, borderColor: 'divider', mb: 3,
                  '& .Mui-selected': { color: '#FF8C00' },
                  '& .MuiTabs-indicator': { backgroundColor: '#FF8C00' }
                }}
              >
                <Tab value="configurar" icon={<Settings />} label="Configurar" iconPosition="start" />
                <Tab value="preview" icon={<Preview />} label="Pré-visualizar" iconPosition="start" />
                <Tab value="codigo" icon={<Code />} label="Código Embed" iconPosition="start" />
              </Tabs>

              {/* ABA: CONFIGURAR */}
              {widgetAba === 'configurar' && (
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Nome da Empresa"
                      value={widgetConfig.nomeEmpresa}
                      onChange={(e) => setWidgetConfig({ ...widgetConfig, nomeEmpresa: e.target.value })}
                      size="small"
                      helperText="Exibido no cabeçalho do widget"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Título do Widget"
                      value={widgetConfig.titulo}
                      onChange={(e) => setWidgetConfig({ ...widgetConfig, titulo: e.target.value })}
                      size="small"
                      helperText='Ex: "Reserve seu carro"'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Subtítulo"
                      value={widgetConfig.subtitulo}
                      onChange={(e) => setWidgetConfig({ ...widgetConfig, subtitulo: e.target.value })}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Texto do Botão"
                      value={widgetConfig.labelBotao}
                      onChange={(e) => setWidgetConfig({ ...widgetConfig, labelBotao: e.target.value })}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="URL de Destino (seu sistema)"
                      value={widgetConfig.urlDestino}
                      onChange={(e) => setWidgetConfig({ ...widgetConfig, urlDestino: e.target.value })}
                      size="small"
                      helperText="URL para onde o cliente será redirecionado ao buscar"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <TextField
                        label="Cor Principal"
                        type="color"
                        value={widgetConfig.corPrimaria}
                        onChange={(e) => setWidgetConfig({ ...widgetConfig, corPrimaria: e.target.value })}
                        size="small"
                        sx={{ width: 100 }}
                      />
                      <TextField
                        fullWidth
                        value={widgetConfig.corPrimaria}
                        onChange={(e) => setWidgetConfig({ ...widgetConfig, corPrimaria: e.target.value })}
                        size="small"
                        label="Hex"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <TextField
                        label="Cor do Texto"
                        type="color"
                        value={widgetConfig.corTexto}
                        onChange={(e) => setWidgetConfig({ ...widgetConfig, corTexto: e.target.value })}
                        size="small"
                        sx={{ width: 100 }}
                      />
                      <TextField
                        fullWidth
                        value={widgetConfig.corTexto}
                        onChange={(e) => setWidgetConfig({ ...widgetConfig, corTexto: e.target.value })}
                        size="small"
                        label="Hex"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <TextField
                        label="Cor de Fundo"
                        type="color"
                        value={widgetConfig.corFundo}
                        onChange={(e) => setWidgetConfig({ ...widgetConfig, corFundo: e.target.value })}
                        size="small"
                        sx={{ width: 100 }}
                      />
                      <TextField
                        fullWidth
                        value={widgetConfig.corFundo}
                        onChange={(e) => setWidgetConfig({ ...widgetConfig, corFundo: e.target.value })}
                        size="small"
                        label="Hex"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Borda arredondada (px)"
                      type="number"
                      value={widgetConfig.borderRadius}
                      onChange={(e) => setWidgetConfig({ ...widgetConfig, borderRadius: e.target.value })}
                      size="small"
                      inputProps={{ min: 0, max: 50 }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Largura"
                      value={widgetConfig.largura}
                      onChange={(e) => setWidgetConfig({ ...widgetConfig, largura: e.target.value })}
                      size="small"
                      helperText='Ex: "100%", "600px"'
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 1 }}>
                      <Switch
                        checked={widgetConfig.mostrarLogo}
                        onChange={(e) => setWidgetConfig({ ...widgetConfig, mostrarLogo: e.target.checked })}
                        color="warning"
                      />
                      <Typography variant="body2">Mostrar nome da empresa</Typography>
                    </Box>
                  </Grid>
                </Grid>
              )}

              {/* ABA: PRÉ-VISUALIZAR */}
              {widgetAba === 'preview' && (
                <Box>
                  <Alert severity="info" sx={{ mb: 3 }}>
                    Esta é a aparência do widget no site do cliente. Clique em &ldquo;Buscar Veículos&rdquo; para simular o redirecionamento.
                  </Alert>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box
                      sx={{
                        width: widgetConfig.largura,
                        maxWidth: '100%',
                        bgcolor: widgetConfig.corFundo,
                        borderRadius: `${widgetConfig.borderRadius}px`,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                        overflow: 'hidden',
                        border: '1px solid #e0e0e0'
                      }}
                    >
                      {/* Header do widget */}
                      <Box sx={{ bgcolor: widgetConfig.corPrimaria, px: 3, py: 2 }}>
                        {widgetConfig.mostrarLogo && (
                          <Typography variant="caption" sx={{ color: widgetConfig.corTexto, opacity: 0.85, display: 'block', mb: 0.5 }}>
                            🚗 {widgetConfig.nomeEmpresa}
                          </Typography>
                        )}
                        <Typography variant="h6" sx={{ color: widgetConfig.corTexto, fontWeight: 700 }}>
                          {widgetConfig.titulo}
                        </Typography>
                        <Typography variant="body2" sx={{ color: widgetConfig.corTexto, opacity: 0.85 }}>
                          {widgetConfig.subtitulo}
                        </Typography>
                      </Box>
                      {/* Formulário de busca */}
                      <Box sx={{ px: 3, py: 3, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: 'flex-end' }}>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>📍 Local de Retirada</Typography>
                          <Box sx={{ border: '1px solid #ddd', borderRadius: `${Math.min(Number(widgetConfig.borderRadius), 8)}px`, px: 1.5, py: 1, bgcolor: '#fafafa' }}>
                            <Typography variant="body2" color="text.disabled">Cidade ou aeroporto</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>📅 Retirada</Typography>
                          <Box sx={{ border: '1px solid #ddd', borderRadius: `${Math.min(Number(widgetConfig.borderRadius), 8)}px`, px: 1.5, py: 1, bgcolor: '#fafafa' }}>
                            <Typography variant="body2" color="text.disabled">dd/mm/aaaa</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>📅 Devolução</Typography>
                          <Box sx={{ border: '1px solid #ddd', borderRadius: `${Math.min(Number(widgetConfig.borderRadius), 8)}px`, px: 1.5, py: 1, bgcolor: '#fafafa' }}>
                            <Typography variant="body2" color="text.disabled">dd/mm/aaaa</Typography>
                          </Box>
                        </Box>
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: widgetConfig.corPrimaria,
                            color: widgetConfig.corTexto,
                            borderRadius: `${widgetConfig.borderRadius}px`,
                            '&:hover': { bgcolor: widgetConfig.corPrimaria, opacity: 0.9 },
                            whiteSpace: 'nowrap',
                            px: 3
                          }}
                          onClick={() => window.open(widgetConfig.urlDestino, '_blank')}
                        >
                          {widgetConfig.labelBotao}
                        </Button>
                      </Box>
                      <Box sx={{ px: 3, pb: 1.5, textAlign: 'right' }}>
                        <Typography variant="caption" color="text.disabled">Powered by Easy Locadora</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}

              {/* ABA: CÓDIGO EMBED */}
              {widgetAba === 'codigo' && (() => {
                const embedCode = `<!-- Widget de Locação de Carros - ${widgetConfig.nomeEmpresa} -->
<div id="easy-locadora-widget"></div>
<script>
(function() {
  var cfg = {
    titulo: ${JSON.stringify(widgetConfig.titulo)},
    subtitulo: ${JSON.stringify(widgetConfig.subtitulo)},
    corPrimaria: ${JSON.stringify(widgetConfig.corPrimaria)},
    corTexto: ${JSON.stringify(widgetConfig.corTexto)},
    corFundo: ${JSON.stringify(widgetConfig.corFundo)},
    labelBotao: ${JSON.stringify(widgetConfig.labelBotao)},
    urlDestino: ${JSON.stringify(widgetConfig.urlDestino)},
    nomeEmpresa: ${JSON.stringify(widgetConfig.nomeEmpresa)},
    mostrarLogo: ${widgetConfig.mostrarLogo},
    borderRadius: ${JSON.stringify(widgetConfig.borderRadius + 'px')},
    largura: ${JSON.stringify(widgetConfig.largura)}
  };

  var container = document.getElementById('easy-locadora-widget');
  if (!container) return;

  container.style.width = cfg.largura;
  container.style.fontFamily = "'Segoe UI', Arial, sans-serif";
  container.style.boxSizing = 'border-box';

  container.innerHTML =
    '<div style="border-radius:' + cfg.borderRadius + ';overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,0.12);border:1px solid #e0e0e0;background:' + cfg.corFundo + '">' +
      '<div style="background:' + cfg.corPrimaria + ';padding:16px 24px">' +
        (cfg.mostrarLogo ? '<span style="color:' + cfg.corTexto + ';opacity:0.85;font-size:12px;display:block;margin-bottom:4px">\uD83D\uDE97 ' + cfg.nomeEmpresa + '</span>' : '') +
        '<div style="color:' + cfg.corTexto + ';font-size:20px;font-weight:700;margin-bottom:4px">' + cfg.titulo + '</div>' +
        '<div style="color:' + cfg.corTexto + ';opacity:0.85;font-size:14px">' + cfg.subtitulo + '</div>' +
      '</div>' +
      '<div style="padding:20px 24px;display:flex;flex-wrap:wrap;gap:12px;align-items:flex-end;background:' + cfg.corFundo + '">' +
        '<div style="flex:1;min-width:160px">' +
          '<label style="font-size:12px;color:#666;display:block;margin-bottom:4px">\uD83D\uDCCD Local de Retirada</label>' +
          '<input id="elw-local" type="text" placeholder="Cidade ou aeroporto" style="width:100%;padding:8px 12px;border:1px solid #ddd;border-radius:6px;font-size:14px;box-sizing:border-box">' +
        '</div>' +
        '<div style="flex:1;min-width:140px">' +
          '<label style="font-size:12px;color:#666;display:block;margin-bottom:4px">\uD83D\uDCC5 Retirada</label>' +
          '<input id="elw-retirada" type="date" style="width:100%;padding:8px 12px;border:1px solid #ddd;border-radius:6px;font-size:14px;box-sizing:border-box">' +
        '</div>' +
        '<div style="flex:1;min-width:140px">' +
          '<label style="font-size:12px;color:#666;display:block;margin-bottom:4px">\uD83D\uDCC5 Devolução</label>' +
          '<input id="elw-devolucao" type="date" style="width:100%;padding:8px 12px;border:1px solid #ddd;border-radius:6px;font-size:14px;box-sizing:border-box">' +
        '</div>' +
        '<button onclick="(function(){' +
          'var local=document.getElementById("elw-local").value;' +
          'var ret=document.getElementById("elw-retirada").value;' +
          'var dev=document.getElementById("elw-devolucao").value;' +
          'var url="' + cfg.urlDestino + '";' +
          'var params=new URLSearchParams();' +
          'if(local) params.set("local",local);' +
          'if(ret) params.set("retirada",ret);' +
          'if(dev) params.set("devolucao",dev);' +
          'window.open(url+(params.toString()?"?"+params.toString():""),"_blank");' +
        '})()" style="background:' + cfg.corPrimaria + ';color:' + cfg.corTexto + ';border:none;padding:10px 24px;border-radius:' + cfg.borderRadius + ';font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap">' +
          cfg.labelBotao +
        '</button>' +
      '</div>' +
      '<div style="padding:4px 24px 12px;text-align:right">' +
        '<span style="font-size:11px;color:#aaa">Powered by Easy Locadora</span>' +
      '</div>' +
    '</div>';
})();
</script>`;

                return (
                  <Box>
                    <Alert severity="success" sx={{ mb: 2 }}>
                      Cole este código no HTML do seu site onde deseja exibir a barra de pesquisa de locação.
                    </Alert>
                    <Box sx={{ position: 'relative' }}>
                      <Button
                        variant="contained"
                        startIcon={<ContentCopy />}
                        size="small"
                        onClick={() => {
                          navigator.clipboard.writeText(embedCode);
                          setWidgetCopiado(true);
                          setTimeout(() => setWidgetCopiado(false), 3000);
                        }}
                        sx={{
                          position: 'absolute', top: 8, right: 8, zIndex: 1,
                          bgcolor: widgetCopiado ? '#2e7d32' : '#FF8C00',
                          '&:hover': { bgcolor: widgetCopiado ? '#1b5e20' : '#E67E00' }
                        }}
                      >
                        {widgetCopiado ? '✓ Copiado!' : 'Copiar Código'}
                      </Button>
                      <Box
                        component="pre"
                        sx={{
                          bgcolor: '#0d1117',
                          color: '#e6edf3',
                          p: 3,
                          pt: 6,
                          borderRadius: 2,
                          overflow: 'auto',
                          fontSize: '12px',
                          fontFamily: 'monospace',
                          lineHeight: 1.6,
                          maxHeight: 480,
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-all',
                          m: 0
                        }}
                      >
                        {embedCode}
                      </Box>
                    </Box>
                    <Alert severity="info" sx={{ mt: 2 }} icon={<Info />}>
                      <strong>Como usar:</strong> Copie o código acima e cole no HTML da página onde deseja exibir o widget. 
                      O widget funciona em qualquer site — WordPress, Wix, HTML puro, etc. 
                      Quando o cliente preencher e clicar no botão, será redirecionado para o sistema de reservas com os dados preenchidos.
                    </Alert>
                  </Box>
                );
              })()}
            </CardContent>
          </Card>
        </Box>
      )}

      {/* TAB INFOSIMPLES (MULTAS) */}
      {tabAtiva === 4 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
              <Gavel sx={{ color: '#FF8C00', fontSize: 32 }} />
              <Box>
                <Typography variant="h6" fontWeight="bold">Infosimples — Consulta de Multas DETRAN-AM</Typography>
                <Typography variant="body2" color="text.secondary">
                  Consulta via API paga. Cadastre seu token para habilitar a consulta automática na tela de Multas.
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ mb: 3 }} />

            {/* Status atual */}
            {infosimplesStatus && (
              <Alert
                severity={infosimplesStatus.tokenCadastrado ? 'success' : 'warning'}
                sx={{ mb: 3 }}
                icon={infosimplesStatus.tokenCadastrado ? <CheckCircle /> : <Cancel />}
              >
                {infosimplesStatus.tokenCadastrado
                  ? `Token configurado — atualizado em ${new Date(infosimplesStatus.atualizado_em).toLocaleString('pt-BR')}`
                  : 'Nenhum token cadastrado ainda.'}
              </Alert>
            )}

            <Grid container spacing={3} alignItems="flex-start">
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  label="Token Infosimples"
                  placeholder="Cole aqui seu token da API Infosimples"
                  value={infosimplesToken}
                  onChange={(e) => setInfosimplesToken(e.target.value)}
                  type={infosimplesTokenVisivel ? 'text' : 'password'}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><VpnKey /></InputAdornment>,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setInfosimplesTokenVisivel(v => !v)}>
                          {infosimplesTokenVisivel ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  helperText={infosimplesStatus?.tokenCadastrado ? 'Deixe em branco para manter o token atual. Digite um novo para substituir.' : ''}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Endpoint do serviço"
                  value={infosimplesEndpoint}
                  onChange={(e) => setInfosimplesEndpoint(e.target.value)}
                  helperText="Ex: detran/am/multas"
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><Typography variant="caption" sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>/consultas/</Typography></InputAdornment>,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '56px' }}>
                  <Switch
                    checked={infosimplesAtivo}
                    onChange={(e) => setInfosimplesAtivo(e.target.checked)}
                    color="warning"
                  />
                  <Typography variant="body2">{infosimplesAtivo ? 'Integração ativa' : 'Integração inativa'}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  startIcon={salvandoInfosimples ? <CircularProgress size={16} color="inherit" /> : <Save />}
                  disabled={salvandoInfosimples || !infosimplesToken.trim()}
                  onClick={salvarInfosimples}
                  sx={{ bgcolor: '#FF8C00', '&:hover': { bgcolor: '#e07b00' }, mr: 2 }}
                >
                  {salvandoInfosimples ? 'Salvando...' : 'Salvar Token'}
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<OpenInNew />}
                  href="https://infosimples.com/cadastro"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Criar conta na Infosimples
                </Button>
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle2" color="text.secondary" gutterBottom>Como usar</Typography>
            <Box component="ol" sx={{ pl: 2, '& li': { mb: 0.8, fontSize: 14 } }}>
              <li>Acesse <strong>infosimples.com</strong> e crie uma conta.</li>
              <li>No painel da Infosimples, copie seu <strong>token de API</strong>.</li>
              <li>Cole o token acima e clique em <strong>Salvar Token</strong>.</li>
              <li>Na tela de <strong>Multas</strong>, selecione o veículo, abra o painel lateral e clique em <strong>🔍 Infosimples</strong>.</li>
              <li>As multas serão consultadas automaticamente usando o RENAVAM e a placa do veículo.</li>
            </Box>

            <Alert severity="info" sx={{ mt: 2 }}>
              <Typography variant="body2">
                A consulta consome créditos da sua conta Infosimples. Cada consulta de multas DETRAN-AM utiliza 1 crédito.
              </Typography>
            </Alert>
          </CardContent>
        </Card>
      )}

      {/* TAB APLICATIVO */}
      {tabAtiva === 5 && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Android sx={{ fontSize: 40, color: '#FF8C00' }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Aplicativo Móvel
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Baixe o aplicativo Easy Locadora para Android
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Divider sx={{ mb: 3 }} />

            <Alert severity="info" sx={{ mb: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                📱 Aplicativo Disponível para Download
              </Typography>
              <Typography variant="body2">
                Acesse a inspeção de veículos, visualize fotos e gerencie suas locações direto do celular.
              </Typography>
            </Alert>

            <Paper sx={{ p: 3, bgcolor: '#fafafa', borderRadius: 2, border: '2px solid #FF8C00' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
                <Box sx={{ flex: 1, minWidth: '200px' }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                    Easy Locadora App
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {apkInfo.disponivel ? 'APK Android disponível no R2' : 'Nenhum APK publicado ainda'}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                    <Chip label="Android" size="small" variant="outlined" />
                    <Chip label="Offline Capable" size="small" variant="outlined" />
                  </Box>
                  <Button
                    variant="contained"
                    startIcon={<CloudDownload />}
                    disabled={!apkInfo.disponivel || apkInfo.gerando}
                    onClick={() => window.open(apkInfo.url, '_blank', 'noopener,noreferrer')}
                    sx={{ bgcolor: '#FF8C00', '&:hover': { bgcolor: '#E67E00' } }}
                  >
                    Baixar APK
                  </Button>
                  {apkInfo.atualizadoEm && (
                    <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 1 }}>
                      Atualizado em {new Date(apkInfo.atualizadoEm).toLocaleString('pt-BR')}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ textAlign: 'center' }}>
                  <Android sx={{ fontSize: 80, color: '#3DDC84', opacity: 0.3 }} />
                </Box>
              </Box>
            </Paper>

            <Box sx={{ mt: 4 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                ℹ️ Como Instalar
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 2 }}>
                <ol style={{ margin: '8px 0', paddingLeft: '20px', lineHeight: 1.8 }}>
                  <li>Clique no botão <strong>"Baixar APK"</strong> acima</li>
                  <li>O arquivo será baixado para seu celular</li>
                  <li>Abra o gerenciador de arquivos do seu celular</li>
                  <li>Localize o arquivo <code>easy-locadora.apk</code></li>
                  <li>Toque no arquivo para instalar</li>
                  <li>Aceite as permissões solicitadas</li>
                  <li>Pronto! O aplicativo está instalado</li>
                </ol>
              </Typography>
            </Box>

            <Alert severity="warning" sx={{ mt: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                ⚠️ Versão de Desenvolvimento
              </Typography>
              <Typography variant="body2">
                Este é o aplicativo em versão de desenvolvimento (Debug). Para uma versão de produção estável, entre em contato com o suporte.
              </Typography>
            </Alert>

            <Box sx={{ mt: 3, p: 2, bgcolor: '#e3f2fd', borderRadius: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                Recursos Principais:
              </Typography>
              <Box component="ul" sx={{ pl: 2, mb: 0, '& li': { mb: 0.5, fontSize: '14px' } }}>
                <li>✅ Inspeção de veículos com câmera</li>
                <li>✅ Upload de fotos e documentos</li>
                <li>✅ Visualização de rentais</li>
                <li>✅ Modo offline com sincronização</li>
                <li>✅ Autenticação segura</li>
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* MODAL QR CODE WHATSAPP */}
      <Dialog 
        open={modalQRCode} 
        onClose={cancelarConexaoWhatsApp} 
        maxWidth="sm" 
        fullWidth
        disableEscapeKeyDown={false}
      >
        <DialogTitle sx={{ bgcolor: '#25D366', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
          <QrCode2 /> Conectar WhatsApp
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', py: 3 }}>
          {qrCodeAtual ? (
            <>
              <img 
                src={qrCodeAtual} 
                alt="QR Code WhatsApp" 
                style={{ width: '100%', maxWidth: 350, borderRadius: 8, marginBottom: 16 }}
              />
              <Box sx={{ mt: 2 }}>
                <Chip 
                  label={`Expira em: ${Math.floor(tempoQR / 60)}:${(tempoQR % 60).toString().padStart(2, '0')}`}
                  color="warning"
                  icon={<Schedule />}
                />
              </Box>
              <Typography variant="body2" sx={{ mt: 3, mb: 2 }}>
                📱 <strong>Como conectar:</strong>
              </Typography>
              <Typography variant="body2" component="div" sx={{ textAlign: 'left', pl: 3 }}>
                <ol>
                  <li>Abra o WhatsApp no seu celular</li>
                  <li>Toque em <strong>Menu</strong> → <strong>Dispositivos Conectados</strong></li>
                  <li>Toque em <strong>Conectar Dispositivo</strong></li>
                  <li>Aponte a câmera para este QR Code</li>
                </ol>
              </Typography>
            </>
          ) : (
            <Box sx={{ py: 4 }}>
              <CircularProgress size={60} sx={{ color: '#25D366' }} />
              <Typography variant="body2" sx={{ mt: 2 }}>Gerando QR Code...</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelarConexaoWhatsApp} color="error">
            Cancelar Conexão
          </Button>
        </DialogActions>
      </Dialog>

      {/* MODAL TESTE DE MENSAGEM WHATSAPP */}
      <Dialog open={modalTeste} onClose={() => setModalTeste(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor: '#25D366', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Send /> Enviar Mensagem de Teste
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography variant="body2">
              Envie uma mensagem de teste para verificar se a integração está funcionando corretamente.
            </Typography>
          </Alert>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Número do WhatsApp"
                placeholder="(27) 99999-9999"
                value={numeroTesteMensagem}
                onChange={(e) => {
                  // Aplicar máscara de telefone
                  let valor = e.target.value.replace(/\D/g, '');
                  
                  if (valor.length <= 11) {
                    // Formato: (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
                    valor = valor.replace(/^(\d{2})(\d)/g, '($1) $2');
                    valor = valor.replace(/(\d)(\d{4})$/, '$1-$2');
                  } else if (valor.length <= 13) {
                    // Formato com DDI: +XX (XX) XXXXX-XXXX
                    valor = valor.replace(/^(\d{2})(\d{2})(\d)/g, '+$1 ($2) $3');
                    valor = valor.replace(/(\d)(\d{4})$/, '$1-$2');
                  }
                  
                  setNumeroTesteMensagem(valor);
                }}
                helperText="Digite com DDD: (27) 99999-9999"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Mensagem"
                multiline
                rows={4}
                value={textoTesteMensagem}
                onChange={(e) => setTextoTesteMensagem(e.target.value)}
                defaultValue="Olá! Esta é uma mensagem de teste do Easy Locadora"
                helperText="Digite a mensagem que deseja enviar"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalTeste(false)} disabled={enviandoTeste}>
            Cancelar
          </Button>
          <Button 
            onClick={enviarMensagemTeste} 
            variant="contained" 
            disabled={enviandoTeste || !numeroTesteMensagem || !textoTesteMensagem}
            startIcon={enviandoTeste ? <CircularProgress size={20} /> : <Send />}
            sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#128C7E' } }}
          >
            {enviandoTeste ? 'Enviando...' : 'Enviar Mensagem'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal Teste E-mail */}
      <Dialog open={modalTesteEmail} onClose={() => setModalTesteEmail(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Email sx={{ color: '#FF8C00' }} />
            <Typography variant="h6">Enviar E-mail de Teste</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <TextField
              fullWidth
              label="E-mail de Destino"
              type="email"
              value={emailTeste}
              onChange={(e) => setEmailTeste(e.target.value)}
              placeholder="exemplo@email.com"
              helperText="Digite o e-mail para receber o teste"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalTesteEmail(false)} disabled={enviandoEmailTeste}>
            Cancelar
          </Button>
          <Button 
            onClick={testarConfiguracaoEmail} 
            variant="contained" 
            disabled={enviandoEmailTeste || !emailTeste}
            startIcon={enviandoEmailTeste ? <CircularProgress size={20} /> : <Send />}
            sx={{ bgcolor: '#FF8C00', '&:hover': { bgcolor: '#E67E00' } }}
          >
            {enviandoEmailTeste ? 'Enviando...' : 'Enviar E-mail'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* SNACKBAR: WhatsApp conectado com sucesso */}
      <Snackbar
        open={snackbarSucesso}
        autoHideDuration={6000}
        onClose={() => setSnackbarSucesso(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbarSucesso(false)}
          severity="success"
          variant="filled"
          sx={{ width: '100%', fontSize: 16 }}
        >
          ✅ WhatsApp conectado com sucesso!
        </Alert>
      </Snackbar>

      {/* MODAL ADMINISTRAÇÃO WHATSAPP */}
      <Dialog 
        open={modalAdminWhatsApp} 
        onClose={() => setModalAdminWhatsApp(false)} 
        maxWidth="md" 
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: '#25D366', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Settings /> Administração WhatsApp
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          
          {/* Backend Info - Redis/DB/Local */}
          <Accordion
            expanded={expandedPanel === 'backend'}
            onChange={() => setExpandedPanel(expandedPanel === 'backend' ? '' : 'backend')}
            sx={{ mb: 2 }}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Terminal color="primary" />
                <Typography sx={{ fontWeight: 600 }}>🔴 Armazenamento de Sessão</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {carregandoBackendInfo ? (
                <Box sx={{ textAlign: 'center', py: 2 }}>
                  <CircularProgress size={30} />
                </Box>
              ) : backendInfo ? (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Paper sx={{ p: 2, bgcolor: '#f3f3f3', borderLeft: `4px solid ${
                      backendInfo.backend === 'redis' ? '#FF0000' :
                      backendInfo.backend === 'database' ? '#0066CC' :
                      '#666666'
                    }` }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                          <Typography variant="caption" color="text.secondary">Backend Ativo</Typography>
                          <Typography variant="h6" sx={{ fontWeight: 600, mt: 0.5 }}>
                            {backendInfo.backend === 'redis' && '🔴 Redis'}
                            {backendInfo.backend === 'database' && '💾 MySQL Database'}
                            {backendInfo.backend === 'local' && '📁 Arquivo Local'}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                            {backendInfo.descricao}
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>

                  {backendInfo.redis && (
                    <Grid item xs={12}>
                      <Paper sx={{ p: 2, bgcolor: backendInfo.redis.conectado ? '#e8f5e9' : '#ffebee' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                          📡 Status Redis
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="body2">
                            <strong>Conectado:</strong> {backendInfo.redis.conectado ? '✅ Sim' : '❌ Não'}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Host:</strong> {backendInfo.redis.host}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Porta:</strong> {backendInfo.redis.port}
                          </Typography>
                        </Box>
                        {backendInfo.redis.erro && (
                          <Typography variant="caption" color="error">
                            Erro: {backendInfo.redis.erro}
                          </Typography>
                        )}
                      </Paper>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <Alert severity="info" icon={<Info />}>
                      <Typography variant="body2">
                        <strong>Como funciona:</strong> A sessão do WhatsApp é salva em <strong>{backendInfo.backend === 'redis' ? 'Redis (cache)' : backendInfo.backend === 'database' ? 'Banco de Dados MySQL' : 'arquivo local'}</strong>, permitindo que a conexão persista entre reinicializações do servidor.
                      </Typography>
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                <Alert severity="warning">Erro ao carregar informações do backend</Alert>
              )}
            </AccordionDetails>
          </Accordion>

          {/* Informações da Sessão */}
          <Accordion
            expanded={expandedPanel === 'info'}
            onChange={() => setExpandedPanel(expandedPanel === 'info' ? '' : 'info')}
            sx={{ mb: 2 }}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Info color="primary" />
                <Typography sx={{ fontWeight: 600 }}>Informações da Sessão</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                    <Typography variant="caption" color="text.secondary">Status</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {whatsappConfig.conectado ? '🟢 Conectado' : '🔴 Desconectado'}
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                    <Typography variant="caption" color="text.secondary">Número</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {whatsappConfig.numero ? `+${whatsappConfig.numero}` : '-'}
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                    <Typography variant="caption" color="text.secondary">Nome do Perfil</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {whatsappConfig.nome || '-'}
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                    <Typography variant="caption" color="text.secondary">Última Conexão</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {whatsappConfig.ultimaConexao 
                        ? new Date(whatsappConfig.ultimaConexao).toLocaleString('pt-BR')
                        : '-'
                      }
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>

              {/* Informações de Sessão */}
              <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  💾 Persistência de Sessão
                </Typography>
                <Paper sx={{ p: 2, bgcolor: '#e3f2fd' }}>
                  <Typography variant="body2">✅ Sessão salva com backup em múltiplos backends</Typography>
                  <Typography variant="caption" color="text.secondary">
                    • <strong>Principal:</strong> MySQL Database<br />
                    • <strong>Cache:</strong> Redis (se disponível)<br />
                    • <strong>Fallback:</strong> Arquivo local no servidor<br /><br />
                    A sessão persiste entre reinicializações sem necessidade de escanear o QR Code novamente.
                  </Typography>
                </Paper>
              </Box>
            </AccordionDetails>
          </Accordion>

          {/* Histórico de Mensagens */}
          <Accordion 
            expanded={expandedPanel === 'historico'} 
            onChange={() => setExpandedPanel(expandedPanel === 'historico' ? '' : 'historico')}
            sx={{ mb: 2 }}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <History color="primary" />
                <Typography sx={{ fontWeight: 600 }}>Histórico de Mensagens</Typography>
                <Chip 
                  label={historicoMensagens.length} 
                  size="small" 
                  color="primary"
                />
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {loadingHistorico ? (
                <Box sx={{ textAlign: 'center', py: 3 }}>
                  <CircularProgress />
                </Box>
              ) : historicoMensagens.length === 0 ? (
                <Alert severity="info">
                  Nenhuma mensagem encontrada no histórico
                </Alert>
              ) : (
                <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Data/Hora</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Número</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Tipo</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Mensagem</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historicoMensagens.map((msg, index) => (
                        <TableRow key={index} hover>
                          <TableCell>
                            <Typography variant="caption">
                              {new Date(msg.enviado_em).toLocaleString('pt-BR')}
                            </Typography>
                          </TableCell>
                          <TableCell>{msg.numero}</TableCell>
                          <TableCell>
                            <Chip 
                              label={msg.tipo} 
                              size="small"
                              color={msg.tipo === 'enviada' ? 'success' : 'info'}
                            />
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ 
                              maxWidth: 200, 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}>
                              {msg.mensagem}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Chip 
                              label={msg.status} 
                              size="small"
                              color="success"
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  size="small"
                  startIcon={<Refresh />}
                  onClick={carregarHistoricoMensagens}
                  disabled={loadingHistorico}
                >
                  Atualizar
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>

          {/* Estatísticas */}
          <Accordion 
            expanded={expandedPanel === 'stats'} 
            onChange={() => setExpandedPanel(expandedPanel === 'stats' ? '' : 'stats')}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Assessment color="primary" />
                <Typography sx={{ fontWeight: 600 }}>Estatísticas</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#e8f5e9' }}>
                    <Typography variant="h4" sx={{ fontWeight: 600, color: '#2e7d32' }}>
                      {historicoMensagens.filter(m => m.tipo === 'enviada').length}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Mensagens Enviadas
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#e3f2fd' }}>
                    <Typography variant="h4" sx={{ fontWeight: 600, color: '#1976d2' }}>
                      {historicoMensagens.filter(m => m.tipo === 'recebida').length}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Mensagens Recebidas
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#fff3e0' }}>
                    <Typography variant="h4" sx={{ fontWeight: 600, color: '#f57c00' }}>
                      {new Set(historicoMensagens.map(m => m.numero)).size}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Contatos Únicos
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>

              <Box sx={{ mt: 3 }}>
                <Alert severity="success" icon={<CheckCircle />}>
                  <Typography variant="body2">
                    <strong>Tempo de Atividade:</strong> Conectado e funcionando
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Sistema operando normalmente
                  </Typography>
                </Alert>
              </Box>
            </AccordionDetails>
          </Accordion>

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalAdminWhatsApp(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar de notificação genérica */}
      <Snackbar
        open={notificacao.aberto}
        autoHideDuration={5000}
        onClose={() => setNotificacao(prev => ({ ...prev, aberto: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setNotificacao(prev => ({ ...prev, aberto: false }))}
          severity={notificacao.tipo}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notificacao.mensagem}
        </Alert>
      </Snackbar>

      {/* Dialog de confirmação genérica */}
      <Dialog
        open={confirmDialog.aberto}
        onClose={() => { confirmDialog.resolve?.(false); setConfirmDialog(prev => ({ ...prev, aberto: false })); }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{confirmDialog.titulo}</DialogTitle>
        <DialogContent>
          <Typography variant="body2">{confirmDialog.mensagem}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { confirmDialog.resolve?.(false); setConfirmDialog(prev => ({ ...prev, aberto: false })); }}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => { confirmDialog.resolve?.(true); setConfirmDialog(prev => ({ ...prev, aberto: false })); }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Logs ao Vivo */}
      <Dialog
        open={modalLogsAberto}
        onClose={() => { setModalLogsAberto(false); desconectarSSELogs(); }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: '#0d1117', color: '#c9d1d9', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Terminal sx={{ color: '#25D366' }} />
          Logs ao Vivo
          {sseRef.current && <Chip label="AO VIVO" color="success" size="small" sx={{ ml: 1 }} />}
        </DialogTitle>
        <DialogContent sx={{ p: 0, bgcolor: '#0d1117' }}>
          <Paper
            sx={{
              bgcolor: '#0d1117',
              borderRadius: 0,
              p: 2,
              height: 420,
              overflowY: 'auto',
              fontFamily: 'monospace',
              fontSize: 13,
            }}
          >
            {logs.length === 0 ? (
              <Typography sx={{ color: '#8b949e', fontFamily: 'monospace', fontSize: 13 }}>
                Aguardando logs... Clique em &quot;Conectar WhatsApp&quot; para iniciar.
              </Typography>
            ) : (
              logs.map((log) => {
                const cores = { sucesso: '#3fb950', erro: '#f85149', aviso: '#d29922', info: '#79c0ff' };
                const prefixos = { sucesso: '✅', erro: '❌', aviso: '⚠️', info: 'ℹ️' };
                return (
                  <Box key={log.id} sx={{ mb: 0.5, display: 'flex', gap: 1 }}>
                    <Typography component="span" sx={{ color: '#8b949e', fontFamily: 'monospace', fontSize: 12, minWidth: 70 }}>
                      {log.hora}
                    </Typography>
                    <Typography component="span" sx={{ color: cores[log.nivel] || '#c9d1d9', fontFamily: 'monospace', fontSize: 13 }}>
                      {prefixos[log.nivel] || ''} {log.mensagem}
                    </Typography>
                  </Box>
                );
              })
            )}
            <div ref={logsEndRef} />
          </Paper>
        </DialogContent>
        <DialogActions sx={{ bgcolor: '#161b22', borderTop: '1px solid #30363d' }}>
          <Button size="small" color="error" onClick={() => setLogs([])}>
            Limpar
          </Button>
          <Button onClick={() => { setModalLogsAberto(false); desconectarSSELogs(); }} sx={{ color: '#8b949e' }}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}
